export const endpoint = {
  caseTableView: 'case/report/favourite',
  getExternalUrl: (externalUrlId: number) => `externalUrl/${externalUrlId}`
};
export const CASE_TABLE_VIEW_MAX_RESULTS = 50;
export const MOBILE_BREAKPOINT = 576;
export const CASE_NO_COLUMN_NAME = 'CaseNo';
export const MAX_WIDTH_INCREASE_RATE = .1;

export const caseTableViewTranslation = {
  textDeleteCaseTitle: 5790,
  textDeleteCaseContinue: 5790,
  textDeleteCaseDescription: 7489,
  textDeleteCaseCancel: 7956,
  textEditCase: 7485,
  textOpenCase: 7437,
  textDuplicateCaseTitle: 7492,
  textOpenBowtieTitle: 7716,
  textShareCase: 8064,
  textShareCaseByEmail: 8065,
  textPrintCase: 3040,
  textEvaluationValidFrom: 6448,
  textEvaluationDescription: 6446,
  textEvaluationHideInReport: 6507,
  textAddEvaluationSubtitle: 9315,
  textAddEvaluationTitle: 9312,
  textEvaluationAddItem: 9281,
  textAddResidualEvaluation: 9313,
  textEvaluationCopyFromPreviousResidual: 9307,
  noColumnsWereSelected: 9379,
  share_case: 8064,
  textOpenInSurveyManager: 7122
};

export const columnMinimumWidth = {
  typeString: 250,
  typeDate: 150,
  codeTableFlat: 180,
  codeTableFlatMultiple: 180,
  codeTableHierarchical: 200,
  codeTableHierarchicalMultiple: 200
};
